import currentScreen from '../containers/Pages/CreateCourse/Slices/currentScreen';
import unitSlice from '../containers/Pages/CreateCourse/Slices/unitSlice';
import activeTabSlice from '../common/components/Sidebar/activeTabSlice';
import currentCourse from '../containers/Pages/CreateCourse/Slices/currentCourse';
import courseDetailsActiveTabSlice from '../containers/Pages/CourseOverview/tabSlice';
import selectedContentSlice from '../containers/Pages/Courseunit/selectedContentSlice';
import activeState from '../containers/Pages/Settings/activeState';
import authSlice from '../containers/Auth/AuthSlices/authSlice';

const rootReducer = {
     currentScreen,
     unitSlice,
     activeTabSlice,
     currentCourse,
     courseDetailsActiveTabSlice: courseDetailsActiveTabSlice,
     selectedContentSlice: selectedContentSlice,
     activeState: activeState,
     auth: authSlice
};

export default rootReducer;
